import * as types from './actionTypes';

// ========== LISTAR ==========
export const fetchAreasRequest = (filters = {}) => ({
  type: types.FETCH_AREAS_REQUEST,
  payload: { filters }
});

export const fetchAreasSuccess = (data, pagination) => ({
  type: types.FETCH_AREAS_SUCCESS,
  payload: { data, pagination }
});

export const fetchAreasFailure = (error) => ({
  type: types.FETCH_AREAS_FAILURE,
  payload: { error }
});

// ========== BUSCAR POR ID ==========
export const fetchAreaByIdRequest = (id) => ({
  type: types.FETCH_AREA_BY_ID_REQUEST,
  payload: { id }
});

export const fetchAreaByIdSuccess = (data) => ({
  type: types.FETCH_AREA_BY_ID_SUCCESS,
  payload: { data }
});

export const fetchAreaByIdFailure = (error) => ({
  type: types.FETCH_AREA_BY_ID_FAILURE,
  payload: { error }
});

// ========== CRIAR ==========
export const createAreaRequest = (data, callback) => ({
  type: types.CREATE_AREA_REQUEST,
  payload: { data, callback }
});

export const createAreaSuccess = (data) => ({
  type: types.CREATE_AREA_SUCCESS,
  payload: { data }
});

export const createAreaFailure = (error) => ({
  type: types.CREATE_AREA_FAILURE,
  payload: { error }
});

// ========== ATUALIZAR ==========
export const updateAreaRequest = (id, data, callback) => ({
  type: types.UPDATE_AREA_REQUEST,
  payload: { id, data, callback }
});

export const updateAreaSuccess = (data) => ({
  type: types.UPDATE_AREA_SUCCESS,
  payload: { data }
});

export const updateAreaFailure = (error) => ({
  type: types.UPDATE_AREA_FAILURE,
  payload: { error }
});

// ========== REMOVER ==========
export const deleteAreaRequest = (id, callback) => ({
  type: types.DELETE_AREA_REQUEST,
  payload: { id, callback }
});

export const deleteAreaSuccess = (id) => ({
  type: types.DELETE_AREA_SUCCESS,
  payload: { id }
});

export const deleteAreaFailure = (error) => ({
  type: types.DELETE_AREA_FAILURE,
  payload: { error }
});

// ========== DUPLICAR ==========
export const duplicateAreaRequest = (id, callback) => ({
  type: types.DUPLICATE_AREA_REQUEST,
  payload: { id, callback }
});

export const duplicateAreaSuccess = (data) => ({
  type: types.DUPLICATE_AREA_SUCCESS,
  payload: { data }
});

export const duplicateAreaFailure = (error) => ({
  type: types.DUPLICATE_AREA_FAILURE,
  payload: { error }
});

// ========== UTILITÁRIOS ==========
export const clearAreaForm = () => ({
  type: types.CLEAR_AREA_FORM
});

export const clearMessages = () => ({
  type: types.CLEAR_MESSAGES
});

export const setFilters = (filters) => ({
  type: types.SET_FILTERS,
  payload: { filters }
});

export const clearFilters = () => ({
  type: types.CLEAR_FILTERS
});